package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.components.debugPrintln
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.login
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Page("/login")
@Composable
fun LoginPage() {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()

    var showPassword by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf(" ") }


    LaunchedEffect(Unit) {
        if (AppGlobal.userData.accessToken.isNotBlank()) {
            when {
                AppGlobal.userData.role == Strings.PLAYER -> {
                    context.router.navigateTo("/player-details")
                }

                AppGlobal.userData.role.equals(Strings.COACH, ignoreCase = true) &&
                        AppGlobal.userData.organization == Strings.INDEPENDENT -> {
                    context.router.navigateTo("/coach-details?userId=${AppGlobal.userData.uid}")
                }

                else -> {
                    context.router.navigateTo("/home")
                }
            }
        }
    }
    val performLogin = {
        if (!isLoading) {
            scope.launch {
                try {
                    val emailInput =
                        (document.getElementById(Res.Id.emailInput) as HTMLInputElement).value
                    val passwordInput =
                        (document.getElementById(Res.Id.passwordInput) as HTMLInputElement).value
                    if (emailInput.isEmpty()) {
                        isError = true
                    } else if (!isValidEmail(email = emailInput)) {
                        isError = true
                    } else if (passwordInput.isEmpty()) {
                        isError = true
                    } else {

                        isLoading = true
                        isError = false

                        val user = login(email = emailInput, password = passwordInput)
                        if (user.status == "success") {
                            AppGlobal.userData = user
                            AppGlobal.imageUrl = user.imageUrl


                            if (user.role.isEmpty() || user.role == "null") {
                                isError = true
                                serverError = "Your role is not defined, contact administrator."
                            } else if (user.disabled) {
                                isError = true
                                serverError = "Your account is disabled, contact administrator."
                            } else if (user.role.equals(Strings.COACH, ignoreCase = true) &&
                                (user.organization == Strings.INDEPENDENT)
                            ) {
                                context.router.navigateTo("/coach-details?userId=${user.uid}")
                            } else {
                                context.router.navigateTo(
                                    when (user.role) {
                                        Strings.PLAYER -> "/player-details"
                                        else -> "/home"
                                    }
                                )
                            }
                        } else {
                            isError = true
                            serverError = "Login Failed"
                        }
                    }
                } catch (_: Exception) {
                    isError = true
                    serverError = "Login Failed"
                } finally {
                    isLoading = false
                }
            }
        }
    }

    Box(
        Modifier.fillMaxSize().color(sitePalette.bodyBackground.rgb),
        contentAlignment = Alignment.Center
    ) {

        Box(
            Modifier.color(Colors.Black).backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .maxWidth(400.px)
                .borderRadius(r = 6.px), contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier.padding(
                    topBottom = 40.px,
                    leftRight = if (window.screen.width < 480) 20.px else 30.px
                ),
            ) {

                FieldTitleText(text = "Login")
                FieldTitleTextNormal(text = "Email") {}
                InputField(
                    errorText = "Please enter an email (e.g. name@domain.com).",
                    inputType = InputType.Email,
                    placeHolder = "",
                    id = Res.Id.emailInput,
                    isError = isError,
                    marginBottom = 3.px,
                    width = if (window.screen.width < 480) 320.px else 350.px,
                    onEnterPress = performLogin
                )
                Column(modifier = Modifier.fillMaxWidth().margin(top = 15.px, bottom = 5.px)) {
                    Row(
                        Modifier.fillMaxWidth(if (window.screen.width < 480) 320.px else 350.px)
                            .margin(top = 10.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormal(text = "Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showPassword) "Hide" else "Show",
                            onClick = { showPassword = !showPassword },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    InputField(
                        errorText = "Enter your password",
                        inputType = if (showPassword) InputType.Text else InputType.Password,
                        placeHolder = "",
                        id = Res.Id.passwordInput,
                        isError = isError,
                        marginBottom = 0.px,
                        width = if (window.screen.width < 480) 320.px else 350.px,
                        onEnterPress = performLogin
                    )
                }

                FieldTitleTextNormal(
                    isClickable = true,
                    text = "Forgot password?",
                    color = sitePalette.primary.rgb,
                    marginBottom = 10.px,
                    fontSize = 11.px, onClick = {
                        context.router.navigateTo("/forgot-password")
                    }
                )
                Box(Modifier.margin(topBottom = 10.px)) { }
                CommonButton(
                    byPassEmailVerification = true,
                    text = "Log in",
                    isLoading = isLoading,
                    width = if (window.screen.width < 480) 320.px else 350.px,
                    onCLick = {
                        performLogin()
                    }
                )

                // Display server error message
                if (serverError.isNotBlank()) {
                    Box(
                        modifier = Modifier.margin(topBottom = 5.px).fillMaxWidth()
                            .align(Alignment.CenterHorizontally),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = serverError,
                            fontSize = 13.px,
                            color = sitePalette.textErrorColor.rgb, onClick = {}
                        )
                    }
                }

                // Display version
                Box(
                    modifier = Modifier.margin(topBottom = 10.px).fillMaxWidth()
                        .align(Alignment.CenterHorizontally),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = Constants.VERSION,
                        fontSize = 11.px,
                        color = Palette.EditTextBorder.rgbLight, onClick = {}
                    )
                }
            }
        }
    }
}




